export default __webpack_public_path__ + "static/media/3031 spice rack D top.981937a7.png";